pscript<!--
 * @Author: scg
 * @Date: 2022-01-08 09:46:44
 * @LastEditTime: 2022-01-08 10:27:05
 * @LastEditors: scg
 * @Description:
-->
<template>
  <view class="account-box">
    <view class="title">{{$t('lastMap.locations')}}</view>
    <div class="mapbox-maps">
      <div id="map"></div>
    </div>
    <!-- <div class="google-map" id="map"></div> -->
    <!-- <image src="../../static/image/mapData.png" style="width: 100%;height: 360rpx;border-radius: 16rpx;" mode=""></image> -->
    <!-- 列表 -->
    <view class="list-box" v-for="(item, index) in dataList" :key="index">
      <view class="round-box"></view>
      <view class="item-test">
        <view class="item-test-top">{{ item.address }}</view>
        <view class="item-test-bottom">{{ item.createtime }}</view>
      </view>
    </view>
    <view style="width: 100%; height: 1px; background-color: #e1e3e6"></view>
    <view class="blue-test" @click="toDetail">{{$t('lastMap.all')}}</view>
  </view>
</template>

<script>
import { lastgps, getMapKeys } from "@/api/user.js";
import mapboxgl from "mapbox-gl";
import "mapbox-gl/dist/mapbox-gl.css";
export default {
  data() {
    return {
      dataList: [],
      infowindows: [],
      map: null,
      lat: 40.772072448457735,
      lng: -73.99482299312687,
    };
  },
  computed: {},
  mounted() {
    this.init();
  },
  methods: {
    toDetail() {},
    async init() {
      const { data } = await lastgps({
        equipment_id: localStorage.getItem("systemId"),
      });
      // this.dataList = data;
      this.dataList = [
        { latitude: 44.96882657863069, longitude: -93.2885300219205 },
      ];
      this.lat = 44.96882657863069;
      this.lng = -93.2885300219205;
      this.initMap();
    },
    async initMap() {
      const ddd = await getMapKeys();
      let list = [
        {
          name: "200 Santa Monica Pier, Santa Monica, CA 90401, United Statess",
          latitude: "34.02686852390601",
          longitude: "-118.49555293439577",
        },
        {
          name: "1200 Getty Center Dr, Los Angeles, CA 90049, United States",
          latitude: "34.1030902710642",
          longitude: "-118.468087116418",
        },
        {
          name:
            "100 Universal City Plaza, Universal City, CA 91608, United States",
          latitude: "34.161063831772466",
          longitude: "-118.35135739001254",
        },
        {
          name: "Los Angeles, CA 90068, United States",
          latitude: "34.1622001707214",
          longitude: "-118.31427853574257",
        },
        {
          name: "2800 E Observatory Rd, Los Angeles, CA 90027, United States",
          latitude: "34.14742657153353",
          longitude: "-118.30191891765256",
        },
        {
          name: "5905 Wilshire Blvd, Los Angeles, CA 90036, United States",
          latitude: "34.08489429490422",
          longitude: "-118.35959713540586",
        },
      ];
      let myIcon = L.icon({
        iconUrl: require("./../assets/img/lastMap.png"),
        iconSize: [27, 40],
        iconAnchor: [15, 32],
      });

      this.map = L.map("map", {
        center: [list[0].latitude, list[0].longitude], // 地图中心
        zoom: 15, //缩放比列
        zoomControl: false, //禁用 + - 按钮
        doubleClickZoom: false, // 禁用双击放大
        attributionControl: false, // 移除右下角leaflet标识
      });
      // styles/
      let name = L.tileLayer(
        // "https://tile.openstreetmap.org/{z}/{x}/{y}.png"
        // "https://a.tile.openstreetmap.org/{z}/{x}/{y}.png"
        `https://api.mapbox.com/styles/v1/mapbox/streets-v9/tiles/256/{z}/{x}/{y}@2x?access_token=${ddd.data.key}`,
        {
          minZoom: 5,
          maxZoom: 18,
        }
      ).addTo(this.map);

      var latlngs = list.map((item) => {
        return [item.latitude, item.longitude];
      });
      let polyline = L.polyline(latlngs, {
        color: "#289329",
      }).addTo(this.map);
      this.map.fitBounds(polyline.getBounds());

      function marker(list, map, index = 0) {
        L.marker([list[index].latitude, list[index].longitude], {
          icon: myIcon,
        }).addTo(map);
        if (list.length - 1 > index) {
          marker(list, map, index + 1);
        }
      }
      marker(list, this.map);
    },
    handLigature() {
      // var polyOptions = {
      //   strokeColor: '#008000', // 颜色
      //   strokeOpacity: 2.0, // 透明度
      //   strokeWeight: 4 // 宽度
      // }
      // // eslint-disable-next-line no-undef
      // const poly = new google.maps.Polyline(polyOptions)
      // poly.setMap(this.map) // 装载
      // this.dataList.forEach((el, index) => {
      //   var path = poly.getPath() // 获取线条的坐标
      //   path.push(
      //     // eslint-disable-next-line no-undef
      //     new google.maps.LatLng(Number(el.latitude), Number(el.longitude))
      //   ) // 为线条添加标记坐标
      //   this.setMarker(Number(el.latitude), Number(el.longitude), el)
      // })
      const map = new google.maps.Map(document.getElementById("map"), {
        mapTypeId: "roadmap",
        center: { lat: this.lat, lng: this.lng },
        zoom: 13,
      });

      const marker = new google.maps.Marker({
        position: { lat: this.lat, lng: this.lng },
        map: map,
      });

      const infowindow = new google.maps.InfoWindow({
        content: ``,
        // content: `<h3>Reykjavik Roasters</h3><p>A good coffee shop</p>`
      });

      marker.addListener("click", () => {
        infowindow.open(map, marker);
      });
    },
    setMarker(lat, lng, el) {
      lat = lat || this.lat;
      lng = lng || this.lng;
      // 建立一個新地標
      // eslint-disable-next-line no-undef
      const marker = new google.maps.Marker({
        position: {
          lat,
          lng,
        },
        icon: {
          url: "https://api.spylix.com/img/location.png",
          // eslint-disable-next-line no-undef
          scaledSize: new google.maps.Size(50, 50),
        },
        map: this.map,
      });

      // eslint-disable-next-line no-undef
      const latLng = new google.maps.LatLng(lat, lng);

      // eslint-disable-next-line no-undef
      var infowindow = new google.maps.InfoWindow({
        content: `<div style="padding: 10px; max-width: 220px">
                        <div style="line-height: 23px;">
                            <span>Latitude</span>
                            <span style="padding-left: 5px">${latLng
                              .lat()
                              .toFixed(7)}</span>
                        </div>
                        <div style="line-height: 23px;">
                            <span>Longitude</span>
                            <span style="padding-left: 5px">${latLng
                              .lng()
                              .toFixed(7)}</span>
                        </div>
                        <div style="line-height: 23px;">
                            <span>Date</span>
                            <span style="padding-left: 5px">2021-10-12 00:31:30</span>
                        </div>
                        <div style="line-height: 23px;">
                            <span>Accuracy</span>
                            <span style="padding-left: 5px">${el.accuracy ||
                              ""}</span>
                        </div>
                        <div style="line-height: 23px;">
                            <span>Address</span>
                            <span style="padding-left: 5px">${el.address}</span>
                        </div>
                    </div>`,
      });

      this.infowindows.push({
        id: el.id,
        infowindow: infowindow,
      });
      // eslint-disable-next-line no-undef
      google.maps.event.addListener(marker, "click", () => {
        this.infowindows.forEach((el) => {
          el.infowindow.close();
        });
        this.$nextTick(() => {
          infowindow.open(this.map, marker);
        });
      });
    },
    // initMap () {
    //   // eslint-disable-next-line no-undef
    //   const map = new google.maps.Map(document.getElementById('map'), {
    //     center: {
    //       lat: this.lat,
    //       lng: this.lng
    //     },
    //     zoom: 15,
    //     maxZoom: 20,
    //     minZoom: 3,
    //     streetViewControl: false,
    //     mapTypeControl: false,
    //     disableDefaultUI: false,
    //     zoomControl: false,
    //     scaleControl: false,
    //     // eslint-disable-next-line no-dupe-keys
    //     mapTypeControl: false,
    //     // eslint-disable-next-line no-dupe-keys
    //     streetViewControl: false
    //   })
    //   this.map = map
    // }
  },
};
</script>

<style scoped>
@import url("https://api.tiles.mapbox.com/mapbox-gl-js/v0.44.2/mapbox-gl.css");
.account-box {
  padding: 32rpx 40rpx;
  box-sizing: border-box;
  background-color: #fff;
  margin: 24rpx;
  border-radius: 24rpx;
  box-shadow: 0 4px 12px -4px rgba(122, 138, 153, 0.2);
}
.account-box .blue-test {
  font-size: 14px;
  color: #0080ff;
  text-align: center;
  font-weight: 400;
  padding-top: 32rpx;
}

.account-box .title {
  font-size: 16px;
  color: #000927;
  font-weight: 700;
  margin-bottom: 16rpx;
}

.account-box .list-box {
  padding: 20rpx 0;
  box-sizing: border-box;
  display: flex;
  align-items: flex-start;
}
.account-box .list-box .round-box {
  width: 16rpx;
  height: 16rpx;
  background-color: #0cd4b0;
  border-radius: 50%;
  margin-top: 10rpx;
}
.account-box .list-box .item-test {
  margin-left: 24rpx;
  width: calc(100% - 16rpx - 24rpx);
}
.account-box .list-box .item-test .item-test-bottom {
  font-size: 12px;
  color: #b4b5b8;
  font-weight: 400;
}
.account-box .list-box .item-test .item-test-top {
  font-size: 13px;
  color: #000927;
  font-weight: 400;
}
.google-map {
  width: 100%;
  height: 200px;
}
.mapbox-maps {
  width: 100%;
  height: 200px;
  position: relative;
  #map {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    .mapboxgl-canvas {
      outline: none;
    }
    // 隐藏mapbox商标
    .mapboxgl-ctrl-logo {
      display: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/lastMap.vue